<template>
<div>
  <a-card :bordered="false" style="padding: 5% 10%">

    <a-form layout="inline"  :label-col="{ span: 5 }">
      <div v-if="!isAdd">

        <a-form-item label="描述" style="width: 100%">
          {{o.describe}}
        </a-form-item>
        <a-form-item label="是否强制更新" style="width: 100%">
          {{o.isforceupdate == 1 ? '是' : '否'}}
        </a-form-item>
        <a-form-item label="version" style="width: 100%">
          {{o.version}}
        </a-form-item>
        <a-form-item label="文件" style="width: 100%">
          {{o.url}}
        </a-form-item>
        <a-form-item style="margin-left: 20%;margin-top: 20px">
          <a-button v-if="!isAdd" @click="isAdd = true" type="primary">添加新的apk</a-button>
        </a-form-item>
      </div>

      <div v-if="isAdd">

        <a-form-item label="描述" style="width: 100%">
          <a-input v-model="newApk.describe"></a-input>
        </a-form-item>
        <a-form-item label="是否强制更新" style="width: 100%">
          <a-radio-group v-model="newApk.isforceupdate">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="0">否</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="version" style="width: 100%">
          <a-input v-model="newApk.version"></a-input>
        </a-form-item>
        <a-form-item label="文件" style="width: 100%">
          <a-upload name="url" :showUploadList="false" :multiple="false" :headers="tokenHeader"
                    :data="newApk" :action="importExcelUrl" @change="handleImportExcel">
            <a-button type="primary" icon="plus">上传APK</a-button>
          </a-upload>
        </a-form-item>
        <a-form-item style="margin-left: 20%;margin-top: 20px">
          <a-button v-if="isAdd" @click="isAdd = false" style="margin-left: 10px">取消添加</a-button>
<!--          <a-button v-if="isAdd" style="margin-left: 10px" type="primary">确认上传</a-button>-->
        </a-form-item>
      </div>
    </a-form>
  </a-card>
</div>
</template>
<script>
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import { getAction } from '@api/manage'

  export default {
    name:'uploadApk',
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}${'/version/updateVersion'}`;
      }
    },
    data(){
      return{
        tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
        setFileData:{
          type:2
        },
        o:{
          url:'文件',
          describe:'描述',
          versioncode:'版本号',
          isforceupdate:'是否强制更新'
        },
        newApk:{
          describe:'',
          version:'',
          isforceupdate:1
        },
        isAdd:false
      }
    },
    created(){
      this.getInfo()
    },
    methods:{
      getInfo(){
        getAction('/version/getVersionMes',).then(res=>{
          this.o = res.data
          this.newApk.versioncode = this.o.versioncode ? this.o.versioncode : ''
        })
      },

      handleImportExcel(info){
        if (info.file.status !== 'uploading') {
          console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
          if (info.file.response) {
            if (info.file.response.code === 200) {
              this.$message.success('导入成功' )
              this.isAdd = false
              this.getInfo()
            } else if (info.file.response.code === 500) {
              this.$message.warn(info.file.response.message)
            }
          } else {
            this.$message.error(`文件导入失败 `);
          }
        } else if (info.file.status === 'error') {
          this.$message.error(`文件导入失败 `);
        }
      },
    }
  }
</script>